import {Component, OnDestroy, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {Dac6ReporterApiService} from '../../../services/dac6-reporter.service';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
    standalone: false,
    selector: 'particle-transaction-case-editor',
  templateUrl: './transaction-case-dialogs.component.html',
  styleUrls: ['./transaction-case-dialogs.component.scss']
})
export class TransactionCaseDialogsComponent implements OnInit, OnDestroy, IDialogView {
  dropdownData$: Observable<any>;
  unSubscribe$ = new Subject<void>();
  selectedCase: any;
  data: DialogModel;
  inputForm: any;
  constructor(private dac6RepoterApiService: Dac6ReporterApiService, private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.dropdownData$ = this.dac6RepoterApiService.getArrangementsByTransactionId(this.data.input.item.id).pipe(takeUntil(this.unSubscribe$));
    this.inputForm = this.formBuilder.group({
      value  : ['', Validators.required]
    });
  }
  onSelectionChange (event) {
    this.selectedCase =  event.value;
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onOkClicked(): boolean {
    this.data.input.selectedCase = this.selectedCase
    return true;
  }
}
